<template>
  <div v-loading="submitLoading" element-loading-text="请稍等...">
      <sponsor-process
          ref="processForm"
          :code="selectForm.formId"
          :preview="selectForm.preview"
          @submitForm="submitForm()"
      ></sponsor-process>
  </div>
</template>

<script>
import {startProcess} from "@/api/design";
import SponsorProcess from "@/views/workspace/WebSponsorProcess";

export default {
  name: "StartApply",
  components: { SponsorProcess },
  data() {
    return {
      selectForm: {},
      formItem: {},
      actives: [],
      submitLoading:false,
      formList: {
        list: [],
        inputs: "",
        searchResult: [],
      },
      pending: {
        list: [],
      },
    };
  },
  methods: {
    submitForm() {
      const form = this.$refs.processForm.getForm();
      const strUserInfo = localStorage.getItem("user");
      let item = {form,
        templateId:form.templateId,
        startUserInfo:JSON.parse(strUserInfo),
        processDefinitionId:form.processDefinitionId,
        formData:this.$refs.processForm.getFormData(),
        processUsers:this.$refs.processForm.getProcessUser(),
      }
      this.$refs.processForm.validate((valid) => {
        if (!valid) {return this.$message.warning("请完善表单内容！");}
        this.submitLoading = true;
        startProcess(item).then(() => {
          this.submitLoading = false;
          this.$message.success("提交成功");
          this.$router.back()
        });
      });
    },
  },
  created() {
    const query = this.$route.query;
    this.selectForm = query.selectForm;
  }
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 800px) {
  .form-item {
    padding: 12px 10px !important;
    width: 150px !important;
    margin: 5px !important;

    &:hover {
      span:last-child {
        display: none !important;
      }
    }
  }
}
</style>
